import React from 'react'
import styled from 'styled-components'
import iconsList, {AhdIconTypes} from '../../../assets/icons/iconslist'
import utils from '../../../utils'
import svg_iconStyles, {svgWrapperStyles} from './svg_icon.styles'

interface ApSvgIconProps extends AhdIconTypes {
  width?: string
  height?: string
}
const apAtomName = {ap_atom_name: 'svgIconAtom'}

const WrapperAtom = styled(({...props}) => (
  <div {...props}>{props.children}</div>
))`
  ${svgWrapperStyles}
`

const SvgIconAtom = styled((props: ApSvgIconProps) => {
  const {ap_type} = props
  return (
    <WrapperAtom {...apAtomName} {...props}>
      {utils.getSvgFromAListArr(iconsList, ap_type)}
    </WrapperAtom>
  )
})`
  ${svg_iconStyles}
`

export default SvgIconAtom
